module.exports = __webpack_public_path__ + "img/XEM-alt.581876a9.svg";